import { STATIC_REDIRECT_ROUTES } from '~/utils/enums';

export const useArticleDetail = () => {
  const { t } = useI18n();
  const route = useRoute();
  const router = useRouter();
  const store = useStore();
  const config = useRuntimeConfig();
  const loading = ref(true);
  const slug = computed(() => route.params.slug);
  const article = computed(() => store.getters['strapi/getByField']('articles'));
  const urlShare = computed(() => `${config.public.APP_BASE_DOMAIN}${route.fullPath}`);
  const reportVersions = computed(() => store.getters['strapi/getByField']('reportVersions'));
  const shareNetworks = computed(() => store.getters['strapi/getByField']('common.social_sharing'));
  const contentTextShare = computed(() =>
    store.getters['strapi/getByField']('common.social_sharing_modal')
  );
  const breadcrumbs = computed(() => {
    if (article.value?.category?.section) {
      const path = article.value.category.section;
      const setterPath = path.includes('actualidad')
        ? route.path.replace(route.params.slug, '').replace(/\//g, '')
        : path;
      return {
        path: setterPath,
        section: t(`breadcrumbs.${setterPath}`)
      };
    } else {
      return null;
    }
  });
  const verifySection = val => {
    if (!val) return false;
    loading.value = true;
    const routeName = route.name || route.matched?.[0]?.name || '';

    try {
      if (val.category?.section && !routeName.includes(`${val.category.section}-slug`)) {
        if (
          slug.value &&
          STATIC_REDIRECT_ROUTES.length &&
          new RegExp(`^(?:${STATIC_REDIRECT_ROUTES.join('|')})$`).test(slug.value)
        ) {
          router.push({ name: `${val.category.section}-slug`, params: { slug: slug.value } });
          return true;
        } else {
          console.error(t('forms.errors.articleNotFound'));
          throw createError({
            statusCode: 404,
            fatal: true
          });
        }
      }
      return false;
    } finally {
      loading.value = false;
    }
  };
  watch(
    article,
    async val => {
      if (val?.infographic_category) {
        const infographicCategorySlug = val.infographic_category.slug;
        if (infographicCategorySlug) {
          await store.dispatch('strapi/getArticleReportVersions', {
            slug: infographicCategorySlug || '',
            article: slug.value
          });
        }
      } else {
        store?.commit('strapi/SET_BY_FIELD', { field: 'reportVersions', value: [] });
      }
    },
    { immediate: true }
  );
  return {
    loading,
    urlShare,
    breadcrumbs,
    shareNetworks,
    verifySection,
    reportVersions,
    contentTextShare
  };
};
